/* global google*/
function isLoggedInUser() {
  return fetch('https://www.wix.com/_api/wix-html-login-webapp/user/getUserDetails', {
    method: 'GET',
    headers: { 'Accept': 'application/json' },
    credentials: 'include',
    cache: 'no-store'
  }).then((httpResponse) => {
    if (httpResponse.ok) {
      return httpResponse.json();
    }
    return Promise.reject("Fetch did not succeed");
  })
    .then((json) => {
      if (json.success && json.payload && json.payload.guid) {
        return true;
      }
      return false;
    })
    .catch((err) => {
      console.error("could not get user details");
    });
}

class GoogleOT extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {

  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name == "sticky") {
      isLoggedInUser().then((isLoggedIn) => {
        if (isLoggedIn) {
          return;
        } else {
          let googleOTScript = document.createElement('script');
          googleOTScript.setAttribute('src', 'https://accounts.google.com/gsi/client');
          googleOTScript.setAttribute('defer', '');
          document.head.appendChild(googleOTScript);
          let container = document.createElement('div');
          container.setAttribute('id', 'g_id_onload');
          container.setAttribute('data-prompt_parent_id', 'g_id_onload');
          container.setAttribute('data-client_id', '352188552355.apps.googleusercontent.com');
          if (newValue == 'true') {
            container.setAttribute('style', 'position: fixed;right:400px;top: 68px;width: 0;height: 0;');
          } else {
            container.setAttribute('style', 'position: absolute ;right:400px;top:55px;width:0;height:0;');
          }
          document.body.appendChild(container);

          let cacheKillerCounter = 0;

          function getCacheKiller() {
            return new Date().getTime() + cacheKillerCounter++;
          }
          const body = '&' + encodeURIComponent('app_url=wix.com');

          function handleCredentialResponse(response) {
            const url = `https://users.wix.com/signin#state=googleOT&id_token=${response.credential}`;
            window.location = url;
          }

          googleOTScript.onload = function () {
            google.accounts.id.initialize({
              client_id: '352188552355.apps.googleusercontent.com',
              callback: handleCredentialResponse,
              cancel_on_tap_outside: false,
              context: 'signup',
              prompt_parent_id: 'g_id_onload'
            });
            google.accounts.id.prompt((notification) => {
              if (notification.isDisplayed()) {
                fetch(`https://frog.wix.com/hls2?src=6&evid=186&app_url=wix.com&_=${getCacheKiller()}`, {
                  method: 'post',
                  mode: 'no-cors',
                  credentials: 'include',
                  headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                  },
                  body
                });
              }
            });
          }
        }
      })
    }
  };

  static get observedAttributes() {
    return ['sticky'];
  }
}

customElements.define('google-one-tap', GoogleOT);
